



























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { ISortOption } from '~/store/types';

@Component
export default class SortDrawer extends Vue {
  @Prop(Array) readonly sortOptions!: ISortOption[];
  @Prop({ type: String, default: 'Sort results by' }) readonly heading!: string;
  selectedOption: ISortOption = { title: '', property: '', direction: -1 };

  created() {
    this.selectedOption = this.sortOptions[0];
  }

  @Emit('sort-select')
  handleSortSelect(option: ISortOption) {
    this.selectedOption = option;
    return option;
  }

  @Watch('sortOptions')
  onOptionsChange(options: ISortOption[]) {
    if (options && options.length) {
      this.selectedOption = options[0];
    }
  }
}
